import { Component, ContentChild, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild, OnDestroy } from '@angular/core'
import { FormControl } from '@angular/forms'
import { TreeService } from '@app/shared/services/tree.service'
import { TreeNode } from 'primeng/api'
import { Tree } from 'primeng/tree'

// eslint-disable-next-line @angular-eslint/component-selector -- legacy camelCase selector used app-wide; renaming is a breaking sweep (YB-1951)
@Component({ selector: 'app-myTree', templateUrl: './myTree.component.html', styleUrls: ['./myTree.component.scss'], standalone: false })
export class MyTreeComponent implements OnInit, OnChanges, OnDestroy {
  /** Tree reference */
  @ViewChild('treeReference') treeReference: Tree

  /** Node render template reference */
  @ContentChild('nodeRender') nodeRender: TemplateRef<any> | null

  /** Data array of objects */
  @Input() data: any = {}

  /** Selection mode by default is single */
  @Input() selectionMode: 'checkbox' | 'single' | 'multiple'

  /** Filter placeholder if has filter filter will enabled */
  @Input() filterPlaceholder: string

  /** Form control */
  @Input() form: FormControl

  /** Additional styling */
  @Input() style: any

  /** Propagate selection down? */
  @Input() propagateSelectionDown: boolean = false

  /** Propagate selection up? */
  @Input() propagateSelectionUp: boolean = true

  /** Is editable nodes */
  @Input() editable: boolean

  /** Add new node label */
  @Input() addNewNodeLabel: string

  /** Chips display object name when has value show chips display of sub object name */
  @Input() chipDisplaySubObjectName: string

  /** * Chips display compare object  */
  @Input() chipDisplayCompareObject: any

  /** Is show gaterix icon */
  @Input() statistics: any[]

  /** Set the elements in the start (clear margin from first child) */
  @Input() setElementsInStart: boolean

  /** Use inline editable instead */
  @Input() inlineEditable: boolean

  /** The child's key and by default is parent_id */
  @Input() childKey: string = 'parent_id'

  /** On node selected */
  @Output() onNodeSelected = new EventEmitter<any>()

  /** On node unselected */
  @Output() onNodeUnselected = new EventEmitter<any>()

  /** On node add output */
  @Output() onNodeAdd = new EventEmitter<any>()

  /** On node delete output */
  @Output() onNodeDelete = new EventEmitter<any>()

  /** On checkbox select output */
  @Output() onCheckBoxSelect = new EventEmitter<any>()

  /** On checkbox unselect output */
  @Output() onCheckBoxUnselect = new EventEmitter<any>()

  /** Selected nodes */
  selection: any

  /** Nodes array */
  nodes: TreeNode[] = []

  /** Is nodes expanded */
  isExpanded: boolean = false

  /** Current selected node */
  currentNode: TreeNode

  /** Serialized value for tests */
  serializedValues: any[]

  constructor(private treeService: TreeService) {}

  ngOnInit(): void {
    this.treeService.init(this.data, this.childKey, this.setElementsInStart)
    this.nodes = this.treeService.nodes
    this.serializedValues = this.treeService.serializedValues
    this.expandAll()
    this.currentNode = this.nodes[0]
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && this.editable) {
      this.treeService.data = this.data
      this.treeService.childKey = this.childKey
      this.treeService.initNodes()
      this.nodes = [...this.treeService.nodes]
      this.serializedValues = this.treeService.serializedValues
      if (!changes['data'].firstChange) {
        this.expandAll()
      }
    }
  }

  get dir() {
    return document.dir
  }

  initNodes() {
    this.treeService.data = this.data
    this.treeService.initNodes()
    this.nodes = [...this.treeService.nodes]
    this.serializedValues = this.treeService.serializedValues
  }

  /**
   * Is chip display
   * @param node
   * @returns
   */
  isChipDisplay(node: any) {
    if (!this.editable && this.chipDisplaySubObjectName && this.chipDisplayCompareObject) {
      if (node.data.obj[this.chipDisplaySubObjectName].find((co: any) => this.chipDisplayCompareObject?.includes(co.id))) {
        return true
      }
      return false
    }
    return false
  }

  chipData(node: TreeNode) {
    return node.data.obj[this.chipDisplaySubObjectName].filter((co: any) => this.chipDisplayCompareObject?.includes(co.id))
  }

  /**
   * Row selected check if only row selected and not checkbox if true emit output
   * @param e Event
   */
  rowSelected(e: any) {
    this.currentNode = e?.node || e

    if (this.selectionMode == 'checkbox') this.onCheckBoxSelect.emit(e.node)
    else this.onNodeSelected.emit(e.node || e)
  }

  /**
   * Row unselect check if only row unselected and not checkbox if true emit output
   * @param e Event
   */
  rowUnselect(e: any) {
    this.currentNode = e?.node || e

    if (this.selectionMode == 'checkbox') this.onCheckBoxUnselect.emit(e.node)
    else this.onNodeUnselected.emit(e.node)
  }

  /**
   * On node add emit output
   * @param e For prevent default
   * @param node Node to delete
   */
  onAdd(e: Event, node?: any) {
    e.preventDefault()
    this.onNodeAdd.emit(node?.data?.id)
  }

  /**
   * On node delete emit output
   * @param e For prevent default
   * @param node Node to delete
   */
  onDelete(e: Event, node: any) {
    e.preventDefault()
    this.onNodeDelete.emit(node)
  }

  /**
   * Expand all nodes
   */
  expandAll() {
    this.isExpanded = true
    this.treeService.expandAll()
  }

  /**
   * Collapse all nodes
   */
  collapseAll() {
    this.isExpanded = false
    this.treeService.collapseAll()
  }

  /**
   * Get icon from statistics object
   * @param node
   */
  iconFromStatistics(node: TreeNode) {
    return this.statistics?.find((st) => st.id.toString() == node.data.id.toString())?.icon
  }

  @Output() onNodeClick = new EventEmitter<TreeNode>()

  selected(e: Event, node: TreeNode) {
    e.preventDefault()
    e.stopPropagation()
    this.currentNode = node
    this.onNodeSelected.emit(node)
    //this.onNodeClick.emit(node) // Emit the click event
  }

  ngOnDestroy() {
    // Clean up any template references
    if (this.nodeRender) {
      this.nodeRender = null
    }
  }
}
